import { render, staticRenderFns } from "./PhysicianViewCompaniesCard.vue?vue&type=template&id=58086c84&"
import script from "./PhysicianViewCompaniesCard.vue?vue&type=script&lang=js&"
export * from "./PhysicianViewCompaniesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports